var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.WL=require("moment");module.exports=$CLJS.WL;